import type { ForgotPasswordSopSection } from "../types";

export const FORGOT_PASSWORD_SOP_SECTIONS: ForgotPasswordSopSection[] = [
  {
    id: "before-you-start",
    titleKey: "forgot-password-sop-before-start-title",
    titleFallback: "Before you start",
    introKey: "forgot-password-sop-before-start-intro",
    introFallback:
      "Use this guide when you cannot sign in because you forgot your password. You do not need to be signed in to reset it.",
    steps: [
      {
        bodyKey: "forgot-password-sop-before-start-1",
        bodyFallback:
          "You will need access to the email address linked to your Kivunova FMS account."
      },
      {
        bodyKey: "forgot-password-sop-before-start-2",
        bodyFallback:
          "If you are already signed in and only want to change your password, use Profile → Password instead. See How to manage your personal profile in Run books."
      },
      {
        bodyKey: "forgot-password-sop-before-start-3",
        bodyFallback:
          "The reset link and one-time code are sent to your email. Check your inbox and spam folder before you try again."
      }
    ]
  },
  {
    id: "start-from-login",
    titleKey: "forgot-password-sop-login-title",
    titleFallback: "Start from the login page",
    introKey: "forgot-password-sop-login-intro",
    introFallback:
      "Open the login page first. The forgot password option is on the same screen where you normally enter your email and password.",
    steps: [
      {
        bodyKey: "forgot-password-sop-login-1",
        bodyFallback: "Go to the Kivunova FMS login page."
      },
      {
        bodyKey: "forgot-password-sop-login-2",
        bodyFallback: "Below the password field, click Forgot password?",
        imageId: "login-page"
      },
      {
        bodyKey: "forgot-password-sop-login-3",
        bodyFallback: "You will be taken to the Forgot Password screen."
      }
    ]
  },
  {
    id: "request-reset",
    titleKey: "forgot-password-sop-request-title",
    titleFallback: "Request a reset link",
    introKey: "forgot-password-sop-request-intro",
    introFallback:
      "Tell the system which account needs a new password. Use the same email you use to sign in.",
    steps: [
      {
        bodyKey: "forgot-password-sop-request-1",
        bodyFallback:
          "On the Forgot Password page, enter the email address for your account."
      },
      {
        bodyKey: "forgot-password-sop-request-2",
        bodyFallback:
          "Click Reset Password. Kivunova FMS will send a reset message to that email.",
        imageId: "request-reset"
      },
      {
        bodyKey: "forgot-password-sop-request-3",
        bodyFallback:
          "Open the email and follow the link inside it. The link opens the Reset Password page."
      },
      {
        bodyKey: "forgot-password-sop-request-4",
        bodyFallback:
          "If you remember your password while waiting, click Login at the bottom of the page to go back without resetting."
      }
    ]
  },
  {
    id: "set-new-password",
    titleKey: "forgot-password-sop-reset-title",
    titleFallback: "Set your new password",
    introKey: "forgot-password-sop-reset-intro",
    introFallback:
      "The reset page asks for the one-time code from your email and your new password. Pick something strong that you have not used elsewhere.",
    steps: [
      {
        bodyKey: "forgot-password-sop-reset-1",
        bodyFallback:
          "On the Reset Password page, enter the one-time code (OTP) from your email."
      },
      {
        bodyKey: "forgot-password-sop-reset-2",
        bodyFallback:
          "Type your new password, then type it again in Confirm Password.",
        imageId: "reset-password"
      },
      {
        bodyKey: "forgot-password-sop-reset-3",
        bodyFallback: "Click Update Password to save your new password."
      },
      {
        bodyKey: "forgot-password-sop-reset-4",
        bodyFallback:
          "If the code has expired or does not work, go back to the Forgot Password page and request a new reset email."
      }
    ]
  },
  {
    id: "sign-in-again",
    titleKey: "forgot-password-sop-sign-in-title",
    titleFallback: "Go back to login and sign in",
    introKey: "forgot-password-sop-sign-in-intro",
    introFallback:
      "After your password is updated, return to the login page and sign in with your email and the new password.",
    steps: [
      {
        bodyKey: "forgot-password-sop-sign-in-1",
        bodyFallback:
          "When the password update is successful, go back to the login page."
      },
      {
        bodyKey: "forgot-password-sop-sign-in-2",
        bodyFallback: "Enter your email and your new password."
      },
      {
        bodyKey: "forgot-password-sop-sign-in-3",
        bodyFallback:
          "Click Log in. You should reach your home screen or portal."
      },
      {
        bodyKey: "forgot-password-sop-sign-in-4",
        bodyFallback:
          "If login still fails, check that caps lock is off and you are using the correct company email. Contact support if you need more help."
      }
    ]
  }
];
